<template>
  <div style="transform: scale(0.5,0.5);">
  <!-- <div> -->
    <div class="box">
      <!-- <img class="box_img" src="@/assets/images/手机预览.png" alt=""> -->
      <div class="box_inner" :style="{backgroundColor:ruleForm.rgb}">
        <div class="head_img">
          <img :src="ruleForm.picUrl" alt="" />
          <!-- 需要加购数字 -->
          <div class="num1" :style="{color: activityData.rgb2}">{{ ruleForm.addCartNum }}</div>
          <div class="shopName">
            <img
              src="https://jdminiapp.yucrm.cn/html/images/gift/icon_shop.png"
              alt
              style="vertical-align: middle"
            />
            {{ sellerNick }}
          </div>
          <div class="rule1">活动规则</div>
          <div class="rule2">我的奖品</div>
        </div>
        <!-- 奖品区 -->
        <div class="prize" v-if="ruleForm.showPrize">
          <img :src="activityData.url2" alt="">
          <div>
            <div class="prize_img">
              <img v-if="prizeList[0].prizeType" :src="imgIcon(prizeList[0].prizeType)" alt="">
            </div>
            <div class="prize_cont">
              <div class="prize_title">{{ prizeList[0].title||'奖品名称' }}</div>
              <div class="prize_num" v-if="ruleForm.showPrizeNum">奖品剩余:&nbsp;&nbsp;{{ prizeList[0].totalAmount }}份</div>
            </div>
          </div>
        </div>
        <!-- 一键加购 -->
        <div class="addAllBtn" v-if="ruleForm.showBatchAddCart" @click="test">
          <img :src="activityData.recommendUrl" alt="">
        </div>
        <!-- 商品区 -->
        <div class="goodsBox">
          <img :src="activityData.secondImageUrl || activityData.cPreviewUrl" alt="">
          <div>
            <div class="goods_item" v-for="item,index in goodsList" :key="item.skuId">
              <div class="item1"><img :src="item.logo" alt=""></div>
              <div class="item2">{{ item.title }}</div>
              <div class="item3">
                <div>{{ item.price }}</div>
                <div v-if="index==0"><img class="img1" src="@/assets/images/已加购.png" alt=""></div>
                <div v-else style="text-align: center;"><img class="img2" src="@/assets/images/Frame.png" alt=""></div>
              </div>
            </div>
            <div style="width:190px;height: 50px;"></div>
          </div>
          <!-- 当前加购数量 -->
          <div class="num2" :style="{color:activityData.rgb2,fontSize: textSize+'px'}">1</div>
        </div>
      </div>
      <!-- 底部导航 -->
      <div class="bottom_nav">
        <img :src="activityData.url3" alt="">
      </div>
    </div>
    <div class="bottomTip">预览效果</div>
  </div>
</template>

<script>
  export default {
    props:{
      activityData:{
        type: Object
      },
      ruleForm:{
        type: Object
      },
      prizeList:{
        type: Array
      },
      goodsList:{
        type: Array
      },
      sellerNick:{
        type: String
      }
    },
    data() {
      return {
        textSize: 0
      }
    },
    created() {
      console.log('手机模型组件=======》',this.activityData,this.ruleForm);
      let num = this.activityData.textSize
      this.textSize = Number(num) + 3
    },
    methods:{
      imgIcon(type){
        // 1:优惠券 2:京豆 3:实物 4:店铺积分 5:京东E卡 6:爱奇艺会员 7:京豆PLUS会员 8:现金红包 
        switch(type){
          case 1:
            return require('@/assets/images/prizeIcon/优惠券.png')
          case 2:
            return require('@/assets/images/prizeIcon/京豆.png')
          case 3:
            return this.prizeList[0].logo
          case 4:
            return require("@/assets/images/prizeIcon/积分.png")
          case 5:
            return require('@/assets/images/prizeIcon/京东E卡.png')
          case 6:
            return require('@/assets/images/prizeIcon/爱奇艺.png')
          case 7:
            return require('@/assets/images/prizeIcon/PLUS.png')
          case 8:
            return require('@/assets/images/prizeIcon/红包.png')
        }
      },
      test(){
        console.log('手机模型组件=======》',this.activityData,this.ruleForm,this.prizeList,this.goodsList);
      }
    }
  }
</script>

<style lang="scss" scoped>
.box{
  width: 504px;
  height: 1004px;
  position: relative;
  background: url("https://yeion-public.s3.cn-north-1.jdcloud-oss.com/phone.png") no-repeat;
  background-size: 505px 1004px !important;
  z-index: 10;
  
  .box_inner{
    width: 456px;
    height: 833px;
    position: absolute;
    left: 25px;
    top: 145px;
    overflow-y: scroll;
    overflow-x: hidden;
    // 隐藏滚动条
    scrollbar-width: none;
    &::-webkit-scrollbar { width: 0 !important };
    -ms-overflow-style: none;

    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    .head_img{
      width: 456px;
      height: 349px;
      position: relative;
      >img{
        width: 100%;
        height: 100%;
      }
      .shopName{
        padding-left: 10px;
        padding-right: 10px;
        position: absolute;
        left: 20px;
        top: 50px;
        // width: 100px;
        line-height: 30px;
        background-color: rgba(0, 0, 0, 0.336);
        color: white;
        font-size: 16px;
        border-radius: 30px;
        img{
          width: 17px;
          margin-top: -2px;
        }
      }
      .rule1{
        position: absolute;
        right: 0px;
        top: 50px;
        background-color: rgba(0, 0, 0, 0.336);
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
        padding-left: 15px;
        padding-right: 10px;
        line-height: 30px;
        color: white;
        font-size: 16px;
      }
      .rule2{
        position: absolute;
        right: 0px;
        top: 100px;
        background-color: rgba(0, 0, 0, 0.336);
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
        padding-left: 15px;
        padding-right: 10px;
        line-height: 30px;
        color: white;
        font-size: 16px;
      }
    }
    .prize{
      width: 410px;
      height: 120px;
      margin: auto;
      margin-top: 18px;
      border-radius: 10px;
      background-color: rgba(0, 0, 0, 0.205);
      position: relative;
      >img{
        width: 385px;
        height: 100px;
        margin-left: 12px;
        margin-top: 10px;
      }
      >div{
        position: absolute;
        left: 24px;
        top: 16px;
        width: 300px;
        height: 90px;
        overflow: hidden;
        display: flex;
        align-items: center;
        .prize_img{
          width: 110px;
          img{
            width: 85px;
            height: 85px;
            border-radius: 8px;
          }
        }
        .prize_cont{
          .prize_title{
            width: 200px;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 10px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;   //设置超出几行省略内容
            text-overflow:ellipsis;
            overflow: hidden;
          }
          .prize_num{
            font-size: 16px;
            color: #7c7c7c;
            margin-top: 2px;
            margin-bottom: 10px;
          }
        }
      }
    }
    .addAllBtn{
      width: 230px;
      height: 64px;
      margin: auto;
      margin-top: 15px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .goodsBox{
      width: 410px;
      height: 322px;
      margin: auto;
      margin-top: 15px;
      position: relative;
      .num2{
        position: absolute;
        display: inline-block;
        width: 25px;
        height: 25px;
        line-height: 25px;
        // font-size: 1px;
        left: 194px;
        top: 4px;
        text-align: center;
      }
      >img{
        width: 100%;
      }
      >div{
        width: 390px;
        height: 680px;
        position: absolute;
        left: 0px;
        top: 30px;
        overflow-y: scroll;
        overflow-x: hidden;
        // 隐藏滚动条
        scrollbar-width: none;
        &::-webkit-scrollbar { width: 0 !important };
        -ms-overflow-style: none;
        // display: flex;
        // justify-content: flex-start;
        // flex-wrap: wrap;
        .goods_item{
          float: left;
          width: 180px;
          height: 260px;
          margin-left: 15px;
          margin-top: 15px;
          background-color: #ffffff;
          border-radius: 5px;
          .item1{
            width: 164px;
            height: 164px;
            margin-left: 8px;
            margin-top: 8px;
            img{
              width: 100%;
              height: 100%;
              border-radius: 5px;
            }
          }
          .item2{
            width: 160px;
            // margin: auto;
            height: 33px;
            margin-left: 10px;
            margin-top: 8px;
            font-size: 16px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;   //设置超出几行省略内容
            text-overflow:ellipsis;
            overflow: hidden;
          }
          .item3{
            width: 160px;
            line-height: 25px;
            margin-top: 8px;
            margin-left: 10px;
            color: red;
            // font-size: 1px;
            display: flex;
            >div{
              flex: 1;
            }
            >div:nth-of-type(1){
              padding-left: 6px;
              font-size: 16px;
            }
            >div:nth-of-type(2){
              padding-right: 3px;
            }
            .img1{
              width: 80px;
              margin-top: 3px;
            }
            .img2{
              width: 20px;
              margin-top: 3px;
            }
          }
        }
      }
    }

  }
}
.num1{
  position: absolute;
  font-size: 16px;
  width: 20px;
  height: 18px;
  text-align: center;
  // background: rgba(255, 0, 0, 0.342);
  left: 180px;
  bottom: 47px;
}

.bottom_nav{
  width: 456px;
  position: absolute;
  bottom: 25px;
  left: 25px;
  img{
    width: 100%;
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.bottomTip{
  text-align: center;
  margin-top: 10px;
  color: #9c9c9c;
  font-size: 30px;
}


</style>